import React, { useEffect, useState, useRef } from "react";
import "./fullattendence.css";
import {
  FaBars, FaUsers, FaRegCalendarAlt,
  FaChevronRight, FaChevronDown, FaTimes,
} from "react-icons/fa";
import { Search } from "lucide-react";

const API        = "https://bodhimaram.onrender.com/api";
const IMAGE_PATH = "https://bodhimaram.onrender.com/uploads/students";

const AttendancePagefull = () => {
  const today   = new Date().toISOString().split("T")[0];
  const dateRef = useRef(null);

  const [groups,            setGroups]            = useState([]);
  const [selectedGroup,     setSelectedGroup]     = useState("");
  const [selectedDate,      setSelectedDate]      = useState(today);
  const [students,          setStudents]          = useState([]);
  const [attendanceList,    setAttendanceList]    = useState([]);
  const [currentAttendance, setCurrentAttendance] = useState([]);
  const [showModal,         setShowModal]         = useState(false);
  const [mobileSearch,      setMobileSearch]      = useState("");

  const formatDate = (d) => new Date(d).toLocaleDateString("en-CA");

  /* fetch groups */
  useEffect(() => {
    fetch("https://bodhimaram.onrender.com/group/groups")
      .then(r => r.json()).then(setGroups);
  }, []);

  /* fetch students */
  useEffect(() => {
    if (!selectedGroup) return;
    (async () => {
      try {
        const res  = await fetch(`${API}/students/${selectedGroup}`);
        const data = await res.json();
        const sd   = Array.isArray(data)
          ? data.map(s => ({ student_id: s.st_id, name: s.childname, student_image: s.student_image || null, status: "P" }))
          : [];
        setStudents(sd);
        const exists = await fetchByDate(selectedDate, sd);
        if (!exists) setCurrentAttendance(sd);
        await loadSummary();
      } catch (e) { console.error(e); }
    })();
  }, [selectedGroup]);

  const loadSummary = async () => {
    if (!selectedGroup) return;
    const res  = await fetch(`${API}/attendance/summary/${selectedGroup}`);
    const data = await res.json();
    setAttendanceList(Array.isArray(data) ? data : []);
  };

  const fetchByDate = async (date, sList = students) => {
    const res  = await fetch(`${API}/attendance/${selectedGroup}/${date}`);
    const data = await res.json();
    if (Array.isArray(data) && data.length) {
      setCurrentAttendance(sList.map(s => {
        const f = data.find(a => a.student_id === s.student_id);
        return { ...s, status: f ? f.status : "P" };
      }));
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (selectedGroup && students.length) fetchByDate(selectedDate, students);
  }, [selectedDate]);

  const openAttendance = async (date) => {
    if (!selectedGroup) return alert("Select group first");
    const d = formatDate(date);
    setSelectedDate(d);
    const ok = await fetchByDate(d, students);
    if (!ok) setCurrentAttendance(students.map(s => ({ ...s })));
    setMobileSearch("");
    setShowModal(true);
  };

  const setStudentStatus = (student_id, status) =>
    setCurrentAttendance(ca => ca.map(s => s.student_id === student_id ? { ...s, status } : s));

  const saveAttendance = async () => {
    const res = await fetch(`${API}/attendance`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        groupCode:  selectedGroup,
        date:       selectedDate,
        attendance: currentAttendance.map(s => ({ student_id: s.student_id, status: s.status })),
      }),
    });
    if (res.ok) { await loadSummary(); setShowModal(false); }
    else alert("Attendance save failed");
  };

  /* desktop coin toggle */
  const toggleStatus = (i) => {
    const c = [...currentAttendance];
    c[i].status = c[i].status === "P" ? "A" : "P";
    setCurrentAttendance(c);
  };

  const groupName      = groups.find(g => g.group_code === selectedGroup)?.name || selectedGroup;
  const filtered       = currentAttendance.filter(s => (s.name || "").toLowerCase().includes(mobileSearch.toLowerCase()));
  const allPresent     = filtered.length > 0 && filtered.every(s => s.status === "P");

  const toggleSelectAll = () =>
    setCurrentAttendance(ca => ca.map(s => {
      const vis = filtered.some(v => v.student_id === s.student_id);
      return vis ? { ...s, status: allPresent ? "A" : "P" } : s;
    }));

  const dayColors = ["mob-day-purple","mob-day-blue","mob-day-green","mob-day-orange","mob-day-pink","mob-day-cyan","mob-day-indigo"];

  return (
    <div className="sgAtten_card">

      {/* ── MOBILE TOP HEADER ── */}
      <div className="mob_header">
        <div className="mob_headerLeft">
         
          <div>
            <h2>Attendance</h2>
            <p>Manage daily attendance</p>
          </div>
        </div>
        
      </div>

      {/* ── MOBILE FILTER PILLS ── */}
      <div className="mob_filterRow">
        <div className="mob_pill">
          <FaUsers className="mob_pillIcon" />
          <select value={selectedGroup} onChange={e => setSelectedGroup(e.target.value)}>
            <option value="">Select Group</option>
            {groups.map(g => <option key={g.group_code} value={g.group_code}>{g.name}</option>)}
          </select>
          <FaChevronDown className="mob_pillChevron" />
        </div>
        <div className="mob_pill" onClick={() => dateRef.current?.showPicker()}>
          <FaRegCalendarAlt className="mob_pillIcon" />
          <span className="mob_pillDateText">
            {new Date(selectedDate).toLocaleDateString("en-GB", { day:"numeric", month:"short", year:"numeric" })}
          </span>
          <input ref={dateRef} type="date" value={selectedDate}
            onChange={e => setSelectedDate(e.target.value)} className="mob_hiddenDate" />
          <FaChevronDown className="mob_pillChevron" />
        </div>
      </div>

      <div className="btn">
        <button className="mob_addBtn" onClick={() => openAttendance(selectedDate)}>
          + Add Attendance
        </button>
      </div>

      {/* ── MOBILE ATTENDANCE RECORDS ── */}
      <div className="mob_records">
        <h3 className="mob_recordsTitle">Attendance Records</h3>
        {attendanceList.length === 0 && <div className="mob_empty">No attendance records</div>}
        <div className="mob_recordList">
          {attendanceList.map(a => {
            const d    = new Date(a.date);
            const col  = dayColors[d.getDay() % dayColors.length];
            return (
              <div className="mob_recordRow" key={a.date} onClick={() => openAttendance(a.date)}>
                <div className={`mob_dayBadge ${col}`}>
                  <span className="mob_dayShort">{d.toLocaleDateString("en-US",{weekday:"short"}).toUpperCase()}</span>
                  <span className="mob_dayNum">{d.getDate()}</span>
                </div>
                <div className="mob_recordMid">
                  <h4>{d.toLocaleDateString("en-US",{weekday:"long"})}</h4>
                  <p>{d.toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"})}</p>
                </div>
                <div className="mob_recordRight">
                  <span className="mob_pPill">{a.present} Present</span>
                  <span className="mob_aPill">{a.absent} Absent</span>
                </div>
                <FaChevronRight className="mob_chevron" />
              </div>
            );
          })}
        </div>
      </div>

      {/* ── DESKTOP TOP BAR ── */}
      <div className="sgAtten_topbar">
        <select value={selectedGroup} onChange={e => setSelectedGroup(e.target.value)} className="sgAtten_groupSelect">
          <option value="">Select Group</option>
          {groups.map(g => <option key={g.group_code} value={g.group_code}>{g.name}</option>)}
        </select>
        <div className="date-wrapper">
          <input type="date" value={selectedDate} onChange={e => setSelectedDate(e.target.value)} className="sgAtten_date" />
          <span className="calendar-icon" onClick={() => dateRef.current.showPicker()}>📅</span>
        </div>
        <button className="sgAtten_addBtn" onClick={() => openAttendance(selectedDate)}>+ Add Attendance</button>
      </div>

      {/* ── DESKTOP TABLE ── */}
      <div className="sgAtten_tableWrap">
        <div className="sgAtten_tableHead"><span>#</span><span>Date</span><span>Total</span><span>Present</span><span>Absent</span><span>Action</span></div>
        {attendanceList.length === 0 && <div className="sgAtten_empty">No attendance records</div>}
        {attendanceList.map((a,i) => (
          <div className="sgAtten_tableRow" key={a.date}>
            <span>{i+1}</span><span>{formatDate(a.date)}</span><span>{a.total}</span>
            <span className="sgAtten_present">{a.present}</span>
            <span className="sgAtten_absent">{a.absent}</span>
            <button className="sgAtten_editBtn" onClick={() => openAttendance(a.date)}>Edit</button>
          </div>
        ))}
      </div>

      {/* ── MODAL ── */}
      {showModal && (
        <div className="sgAtten_modalOverlay">

          {/* Desktop modal */}
          <div className="sgAtten_modal desktopOnly_modal">
            <h3>Attendance – {selectedDate}</h3>
            <div className="sgAtten_studentList">
              {currentAttendance.map((stu,i) => (
                <div key={stu.student_id} className="sgAtten_studentRow">
                  {stu.student_image ? <img src={`${IMAGE_PATH}/${stu.student_image}`} alt={stu.name}/> : <span>-</span>}
                  <span className="sgAtten_studentName">{stu.name}</span>
                  <div className={`sgAtten_coin ${stu.status==="A"?"flip":""}`} onClick={() => toggleStatus(i)}>
                    <div className="coin_face present">P</div>
                    <div className="coin_face absent">A</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="sgAtten_modalActions">
              <button onClick={() => setShowModal(false)}>Cancel</button>
              <button onClick={saveAttendance}>Save</button>
            </div>
          </div>

          {/* Mobile bottom sheet modal */}
          <div className="mob_modal">
            {/* Header */}
            <div className="mob_modalHeader">
              <div>
                <h2>Add Attendance</h2>
                <p>{groupName || "Select Group"} • {new Date(selectedDate).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}</p>
              </div>
              <button className="mob_closeBtn" onClick={() => setShowModal(false)}><FaTimes /></button>
            </div>

            {/* Search */}
            <div className="mob_searchBox">
              <Search size={15} className="mob_searchIcon" />
              <input type="text" placeholder="Search student..." value={mobileSearch} onChange={e => setMobileSearch(e.target.value)} />
            </div>

            {/* Students heading + Select All */}
            <div className="mob_studentsHead">
              <span>Students ({filtered.length})</span>
              <button className={`mob_selectAllBtn ${allPresent ? "all-active" : ""}`} onClick={toggleSelectAll}>
                Select All
                <span className={`mob_selectAllBox ${allPresent ? "checked" : ""}`}>
                  {allPresent && <span className="mob_tick">✓</span>}
                </span>
              </button>
            </div>

            {/* Student list */}
            <div className="mob_studentList">
              {filtered.map(stu => (
                <div className="mob_studentRow" key={stu.student_id}>
                  <div className="mob_studentLeft">
                    {stu.student_image
                      ? <img src={`${IMAGE_PATH}/${stu.student_image}`} alt={stu.name} className="mob_avatar" />
                      : <div className="mob_avatarFallback">{stu.name?.charAt(0)}</div>
                    }
                    <span className="mob_stuName">{stu.name}</span>
                  </div>
                  <div className="mob_studentRight">
                    <button
                      className={`mob_paBtn present-btn ${stu.status==="P" ? "active-p" : ""}`}
                      onClick={() => setStudentStatus(stu.student_id, "P")}
                    >Present</button>
                    <button
                      className={`mob_paBtn absent-btn ${stu.status==="A" ? "active-a" : ""}`}
                      onClick={() => setStudentStatus(stu.student_id, "A")}
                    >Absent</button>
                  </div>
                </div>
              ))}
            </div>

            {/* Footer */}
            <div className="mob_modalFooter">
              <button className="mob_cancelBtn" onClick={() => setShowModal(false)}>Cancel</button>
              <button className="mob_saveBtn" onClick={saveAttendance}>Save Attendance</button>
            </div>
          </div>

        </div>
      )}
    </div>
  );
};

export default AttendancePagefull;